var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAcknowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,70.75A30.72481,30.72481,0,0,0,65.09741,22.26575l5.44751-5.75013-1.08984-1.03124-5.26856,5.56115A30.74119,30.74119,0,1,0,40,70.75Zm0-60A29.21067,29.21067,0,0,1,63.14453,22.14545L33.98535,52.9248,20.53027,39.46973l-1.06054,1.06054,14,14A.74942.74942,0,0,0,34,54.75h.00977a.75229.75229,0,0,0,.53515-.23438l29.502-31.1408A29.23755,29.23755,0,1,1,40,10.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcknowledge);
export default __webpack_public_path__ + "static/media/icon_acknowledge.1860b128ecf6b72943f20660c8328382.svg";
export { ForwardRef as ReactComponent };